import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <section id="home">
          <Hero />
        </section>
        <section id="about" className="section-container">
          <About />
        </section>
        <section id="projects" className="section-container">
          <Projects />
        </section>
        <section id="contact" className="section-container">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;